import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import CloseIcon from "assets/icons/close-big.svg?react";

import BinIcon from "assets/icons/bin.svg?react";
import prettyBytes from "pretty-bytes";

import AttachmentIconComponent from "components/AttachmentIconComponent";
import { useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import { LinearProgress, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const Filedossier: FC<Props> = ({
  file,
  handleRemove,
  onClick,
  index,
  actualFile,
  actualProgress,
  isSelected = false,
  useDrag = false,
  hasError = false,
  errorMessage = null,
  size = "normal",
  newIcons = false,
}) => {
  const { t } = useTranslation();
  const [showOptions, setShowOptions] = useState(false);

  if (!useDrag) {
    return (
      <div
        onMouseEnter={() => setShowOptions(true)}
        onMouseLeave={() => setShowOptions(false)}
        className={`${styles.box} ${isSelected && styles.active} ${
          hasError && styles.error
        } ${size === "small" && styles.small}`}
        onClick={onClick}
        title={errorMessage}
      >
        <div className={styles.wrapper}>
          <AttachmentIconComponent file={file.name} newIcons={newIcons} />
          <div className={styles.information}>
            <div className={styles.name}>{file?.name}</div>
            <div className={styles.size}>{prettyBytes(file.size ?? 0)}</div>
          </div>

          <Tooltip title={t("common.delete")}>
            <div>
              <CloseIcon
                className={styles.icon}
                onClick={(e) => {
                  handleRemove(index);
                  e.stopPropagation();
                }}
              />
            </div>
          </Tooltip>
        </div>
        {actualFile === index && !!actualProgress && (
          <div className={styles.progressBar}>
            <LinearProgress
              color="primary"
              variant={actualProgress !== -1 ? "determinate" : "indeterminate"}
              value={actualProgress}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <Draggable index={index} key={file.name} draggableId={file.name}>
        {(provided) => {
          //@ts-ignore
          provided.draggableProps.style = {
            ...provided.draggableProps.style,
            //@ts-ignore
            cursor: "pointer",
          };
          return (
            <div
              onMouseEnter={() => setShowOptions(true)}
              onMouseLeave={() => setShowOptions(false)}
              className={`${styles.box} ${isSelected && styles.active}`}
              onClick={onClick}
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <div className={styles.wrapper}>
                {showOptions && (
                  <div className={styles.options}>
                    <BinIcon onClick={() => handleRemove(index)} />
                  </div>
                )}
                <AttachmentIconComponent file={file.name} />
                <div className={styles.information}>
                  <div className={styles.name}>{file?.name}</div>
                  <div className={styles.size}>
                    {prettyBytes(file.size ?? 0)}
                  </div>
                </div>
              </div>
              {actualFile === index && !!actualProgress && (
                <div className={styles.progressBar}>
                  <div
                    style={{ width: `${actualProgress}%` }}
                    className={styles.progress}
                  ></div>
                </div>
              )}
            </div>
          );
        }}
      </Draggable>
    </>
  );
};

export default Filedossier;
